/* LAYOUT */
export const GET_DISPATCHES = "GET_DISPATCHES";
export const DISPATCHES_RECEIVED = "DISPATCHES_RECEIVED";
export const CONFIRM_DISPATCH = "CONFIRM_DISPATCH";
export const DISPATCH_CONFIRMED = "DISPATCH_CONFIRMED";